const STORAGE_KEY = 'mycryptoplanner_coin_images';

/** Persist a coin's image URL so it survives beyond the 1-hour coin-list cache. */
export function saveCoinImage(coinId: string, imageUrl: string): void {
  if (!coinId || !imageUrl) return;
  try {
    const existing = loadCoinImages();
    existing[coinId] = imageUrl;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  } catch { /* ignore quota errors */ }
}

/** Load the full coinId → imageUrl map from localStorage. */
export function loadCoinImages(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch { return {}; }
}
